export default [
    // *--------- MAIN WIRES --------------------------------*
    {
        path: '/railway-structure/main-wire/list',
        name: 'railway_structure-main_wire-list',
        component: () => import('@/views/apps/railway_structure/mainWire/views/List.vue'),
        meta: {
            resource: 'mainwire',
            action: 'read',
            pageTitle: 'Несущие провода',
            breadcrumb: [
                {
                  text: 'Структура ЖД',
                    active: true,
                },
                {
                  text: 'Несущие провода',
                  active: true,
                },
            ],
        },
    },

    {
        path: '/railway-structure/main-wire/view/:id',
        name: 'railway_structure-main_wire-view',
        component: () => import('@/views/apps/railway_structure/mainWire/views/Details.vue'),
        meta: {
            resource: 'railway',
            action: 'read',
            pageTitle: 'Несущие провода',
            breadcrumb: [
                {
                    text: 'Структура ЖД',
                    active: true,
                },
                {
                    text: 'Несущие провода',
                    to: {
                        name: 'railway_structure-main_wire-list',
                    }
                },
                {
                    text: 'Детали',
                    active: true
                },
            ],
        },
    },
]
